<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item>个人中心</a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="info-content">
            <a-card title="基本信息" style="width: 100%">
                <a-form :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" @submit="handleSubmit">
                    <div class="formFlex">
                        <a-form-item label="">
                            <div class="index-avatar">
                                <img src="../../../static/head.png" alt="">
                            </div>
                            <span class="index-username">{{info.name}}</span>
                        </a-form-item>
                        <a-form-item class="center-state" label="">
                            <a-icon type="plus" /><span>创建/加入企业</span>
                            <a-divider type="vertical" />
                            <a-icon type="edit" /><span>修改手机号</span>
                        </a-form-item>
                    </div>

                    <div class="formFlex">
                        <a-form-item label="微信账号">
                            <a-input :value="info.wechart" placeholder="请输入微信号"/>
                        </a-form-item>
                        <a-form-item label="电子邮箱">
                            <a-input :value="info.email" placeholder="请输入邮箱"/>
                        </a-form-item>
                    </div>

                    <div class="formFlex">
                        <a-form-item label="QQ号码">
                            <a-input :value="info.qq" placeholder="请输入QQ号码"/>
                        </a-form-item>
                        <a-form-item label="账号">
                            <a-input :value="info.phone" disabled/>
                        </a-form-item>
                    </div>

                    <div class="formFlex">
                        <a-form-item label="企业名称">
                            <a-input :value="info.company_info.name" disabled/>
                        </a-form-item>
                        <a-form-item label="部门">
                            <a-input disabled/>
                        </a-form-item>
                    </div>

                    <div class="formFlex">
                        <a-form-item label="职位">
                            <a-input :value="info.position" disabled/>
                        </a-form-item>
                    </div>
                    
                </a-form>
            </a-card>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            info:""
        }
    },
    mounted(){
           // 通用选项集
        this.$axios.get("/api/userinfo",{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.info=res.data.data
            }else{
                this.$message.error(res.data.msg);
            }
        })
    }
}
</script>




// WEBPACK FOOTER //
// src/components/center/index.vue